import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserPermissions')
export class UserPermissions {
  @JsonProperty('email', String, false) email: string = undefined;
  @JsonProperty('permissions', [String], false) permissions: string[] = undefined;
}
